import { render, staticRenderFns } from "./EditGallery.vue?vue&type=template&id=93827c52&"
import script from "./EditGallery.vue?vue&type=script&lang=js&"
export * from "./EditGallery.vue?vue&type=script&lang=js&"
import style0 from "./EditGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports